import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
} from "@mui/material";
import React, { useState } from "react";
import { cloneComparisonResearchQuerySchema } from "../../schemas";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import AutoCompleteRuleList from "../Molecules/Rule/AutoCompleteRuleList";

interface CloneComparisonResearchQueryDialogProps {
  cloneComparisonResearchQueryDialog: boolean;
  handleCloseCloneComparisonResearchQuery: any;
  cloneComparisonResearchQueryData: any;
  setCloneComparisonResearchQueryData: React.Dispatch<
    React.SetStateAction<any>
  >;
  onSaveCloneComparisonResearchQuery: any;
  setIsLoading?: React.Dispatch<React.SetStateAction<boolean>>;
}

const CloneComparisonResearchQueryDialog = ({
  cloneComparisonResearchQueryDialog,
  handleCloseCloneComparisonResearchQuery,
  cloneComparisonResearchQueryData,
  setCloneComparisonResearchQueryData,
  onSaveCloneComparisonResearchQuery,
  setIsLoading,
}: CloneComparisonResearchQueryDialogProps) => {
  const [errors, setErrors] = useState<{ [key: string]: string }>({});

  const validateField = async (name: any, value: any) => {
    try {
      const partialReferenceData = {
        ...cloneComparisonResearchQueryData,
        [name]: value,
      };
      await cloneComparisonResearchQuerySchema.validateAt(
        name,
        partialReferenceData,
      );
      setErrors((prevErrors) => ({ ...prevErrors, [name]: undefined }));
    } catch (validationError: any) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: validationError.message,
      }));
    }
  };

  const handleSubmit = async () => {
    try {
      await cloneComparisonResearchQuerySchema.validate(
        cloneComparisonResearchQueryData,
        {
          abortEarly: false,
        },
      );
      onSaveCloneComparisonResearchQuery();
    } catch (validationErrors: any) {
      const newErrors: { [key: string]: string } = {};
      validationErrors.inner.forEach(
        (error: { path: string | number; message: string }) => {
          newErrors[error.path] = error.message;
        },
      );
      setErrors(newErrors);
    }
  };

  const handleClose = (reason: string) => {
    if (reason === "backdropClick" || reason === "escapeKeyDown") return;
  };

  const handleCloseDialog = () => {
    setErrors({});
    handleCloseCloneComparisonResearchQuery();
  };

  const handleRuleChange = (_e: any, value: any) => {
    const ruleId = value?.id || null;
    setCloneComparisonResearchQueryData({
      ...cloneComparisonResearchQueryData,
      rule_id: ruleId,
    });
    validateField("rule_id", ruleId);
  };

  return (
    <Dialog
      fullWidth
      maxWidth="md"
      open={cloneComparisonResearchQueryDialog}
      onClose={(event, reason) => handleClose(reason)}
      className="modal-dialog-1"
    >
      <DialogTitle className="dialog-title" component="span">
        <span>Clone Comparison Research Query</span>
        <button className="close-icon" onClick={handleCloseDialog}></button>
      </DialogTitle>
      <DialogContent className="dialog-content">
        <Box>
          <Grid container rowSpacing={3} columnSpacing={3}>
            <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
              <AutoCompleteRuleList
                setIsLoading={setIsLoading || (() => {})}
                handelOnChangeRule={handleRuleChange}
                currentRuleId={
                  cloneComparisonResearchQueryData?.rule_id || null
                }
                required={true}
                error={!!errors?.rule_id}
                helperText={errors?.rule_id || ""}
                listLabel="Select Rule"
                placeholder="Select a rule to clone to..."
                includeRuleId={true}
                filterByComparisonQueryAvailability={true}
                filterByActiveStatus={true}
                className="form-control-autocomplete"
              />
            </Grid>
          </Grid>
        </Box>
      </DialogContent>
      <DialogActions className="dialog-footer">
        <Button
          type="button"
          color="secondary"
          variant="contained"
          onClick={handleSubmit}
          className="btn-orange"
        >
          <SaveOutlinedIcon /> &nbsp; Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CloneComparisonResearchQueryDialog;
